module.exports = __webpack_public_path__ + "static/media/61-mercedes.29c2503a.jpg";